import { motion } from 'framer-motion';

const properties = [
  {
    id: 1,
    name: 'Strip Central A-1',
    location: 'ラスベガス・ストリップ中央',
    roi: 28,
    price: 850000,
    status: '販売中',
    image: 'https://public.readdy.ai/ai/img_res/b5c701dfe81dad4ac2d359dfe8bbb957.jpg',
  },
  {
    id: 2,
    name: 'Highway I-15 North',
    location: 'I-15ハイウェイ北部',
    roi: 24,
    price: 420000,
    status: '販売中',
    image: 'https://readdy.ai/api/search-image?query=Highway%20billboard%20advertisement%20along%20desert%20road%20near%20Las%20Vegas%2C%20clear%20blue%20sky%2C%20modern%20digital%20display%20structure%2C%20cars%20passing%20by%2C%20commercial%20outdoor%20advertising%20photography%2C%20clean%20professional%20composition&width=600&height=400&seq=prop-highway-002&orientation=landscape',
  },
  {
    id: 3,
    name: 'Airport Gateway',
    location: 'マッカラン空港入口',
    roi: 26,
    price: 680000,
    status: '商談中',
    image: 'https://readdy.ai/api/search-image?query=Digital%20billboard%20near%20airport%20entrance%20at%20dusk%2C%20planes%20in%20sky%2C%20modern%20advertising%20display%20with%20warm%20sunset%20lighting%2C%20professional%20commercial%20photography%2C%20Las%20Vegas%20airport%20area%2C%20clean%20urban%20landscape&width=600&height=400&seq=prop-airport-003&orientation=landscape',
  },
  {
    id: 4,
    name: 'Downtown Fremont',
    location: 'フリーモント・ストリート',
    roi: 22,
    price: 380000,
    status: '販売中',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20style%20LED%20billboard%20in%20downtown%20Las%20Vegas%20Fremont%20Street%2C%20classic%20neon%20signs%2C%20retro%20urban%20atmosphere%2C%20night%20photography%20with%20colorful%20lights%2C%20entertainment%20district%20advertising%20display&width=600&height=400&seq=prop-downtown-004&orientation=landscape',
  },
];

export default function PropertyShowcase() {
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  return (
    <section className="py-24 px-6 bg-gray-900">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <span className="inline-block px-4 py-1.5 border border-white/20 text-white/60 rounded-full text-sm mb-4">
              物件タイプ
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-white">
              ラスベガス投資対象ビルボード物件
            </h2>
            <p className="text-gray-400 mt-3">
              ストリップ・ハイウェイ・空港周辺の高収益屋外広告物件
            </p>
          </motion.div>
          <motion.a
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            href="/#contact"
            className="mt-6 md:mt-0 inline-flex items-center gap-2 text-amber-400 hover:text-amber-300 transition-colors cursor-pointer"
          >
            全物件を見る
            <i className="ri-arrow-right-line"></i>
          </motion.a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {properties.map((property, index) => (
            <motion.div
              key={property.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-2xl mb-4">
                <div className="w-full h-56">
                  <img
                    src={property.image}
                    alt={`${property.name} ラスベガス ビルボード投資物件 ${property.location} ROI ${property.roi}%`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="absolute top-4 left-4">
                  <span
                    className={`px-3 py-1 rounded-full text-xs font-medium ${
                      property.status === '販売中'
                        ? 'bg-green-500 text-white'
                        : 'bg-amber-500 text-black'
                    }`}
                  >
                    {property.status}
                  </span>
                </div>
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="bg-white/90 backdrop-blur-sm rounded-xl px-4 py-2">
                    <span className="text-amber-600 font-bold">
                      想定ROI {property.roi}%
                    </span>
                  </div>
                </div>
              </div>
              <h3 className="text-white font-semibold text-lg mb-1">
                {property.name}
              </h3>
              <p className="text-gray-400 text-sm mb-2">{property.location}</p>
              <p className="text-white font-bold text-xl">
                {formatCurrency(property.price)}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
